
export class MenuCustomKeys {
    static readonly eligibilitySearchKey = "EligibilitySearch";
    static readonly paymentTerminalKey = "PaymentTerminal";
    static readonly inventoryOrdersKey = "InventoryOrders";
    static readonly returnItemsKey = "ReturnItems";
}